import React from 'react';

import type { ExtractInjectionAPI, ToolbarUIComponentFactory } from '@atlaskit/editor-common/types';
import { useSharedPluginStateSelector } from '@atlaskit/editor-common/use-shared-plugin-state-selector';
import { EditorView } from '@atlaskit/editor-prosemirror/view';

import type { AIPlugin } from '../../aiPluginType';
import { createOpenAIModalCommand } from '../../pm-plugins/decoration/actions';
import { type AIGlobalOptIn, type EditorPluginAIProvider } from '../../types/types';
import { AtlassianIntelligenceToolbarButton } from '../components/AtlassianIntelligenceToolbarButton/AtlassianIntelligenceToolbarButton';

const PrimaryToolbarLegacyComponent = ({
	api,
	editorView,
	editorPluginAIProvider,
	aiGlobalOptIn,
}: {
	api: ExtractInjectionAPI<AIPlugin> | undefined;
	editorView: EditorView;
	editorPluginAIProvider: EditorPluginAIProvider;
	aiGlobalOptIn: AIGlobalOptIn;
}) => {
	const aiButtonState = useSharedPluginStateSelector(api, 'aiExperience.aiButtonState');
	const onClick = () => {
		const { state, dispatch } = editorView;
		const configItem = editorPluginAIProvider.baseGenerate;
		const openAIModalCommand = createOpenAIModalCommand({
			state,
			configItem,
			lastTriggeredFrom: 'mainToolbar',
			aiGlobalOptIn,
			triggeredFor: aiButtonState?.triggeredFor,
		});
		openAIModalCommand(state, dispatch);
	};
	return (
		<AtlassianIntelligenceToolbarButton
			ButtonWrapper={editorPluginAIProvider?.AIButtonWrapper}
			onClick={onClick}
			disabled={!aiButtonState?.isSelectionValidForAIExperience}
			view={editorView}
		/>
	);
};

export const getPrimaryToolbarLegacyComponent =
	({
		api,
		editorPluginAIProvider,
		aiGlobalOptIn,
	}: {
		api: ExtractInjectionAPI<AIPlugin> | undefined;
		editorPluginAIProvider: EditorPluginAIProvider;
		aiGlobalOptIn: AIGlobalOptIn;
	}): ToolbarUIComponentFactory =>
	({ editorView }) => {
		return (
			<PrimaryToolbarLegacyComponent
				api={api}
				editorView={editorView}
				editorPluginAIProvider={editorPluginAIProvider}
				aiGlobalOptIn={aiGlobalOptIn}
			/>
		);
	};
